// return the user data from the session storage
export const getUser = () => {
  return sessionStorage.getItem('user_key') || null;
};

// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem('access_token') || null;
};

export const getUserRole = () => {
  return sessionStorage.getItem('role') || null;
};

// remove the access_token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('user_key');
};

// set the access_token and user_key from the session storage
export const setUserSession = (access_token, user_key, role = null) => {
  sessionStorage.setItem('access_token', access_token);
  sessionStorage.setItem('user_key', user_key);
  sessionStorage.setItem('role', role);
};

export const getCookie = (cname) => {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
